import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface SelectedTenantStore {
  selectedTenantId: string | null
  setSelectedTenantId: (tenantId: string | null) => void
}

export const useSelectedTenantStore = create<SelectedTenantStore>()(
  persist(
    (set) => ({
      selectedTenantId: null,
      setSelectedTenantId: (tenantId: string | null) =>
        set({ selectedTenantId: tenantId }),
    }),
    {
      name: 'selected-tenant-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
